import { ApplicationProductTypeEnum, Query } from '@varo/graphql-schema-types';
import GetAgreements from 'services/graphql/queries/GetAgreements';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const useAgreements = (agreementTypes: ApplicationProductTypeEnum[]) => {
  const [{ data, fetching: loading, error }, refetchAgreements] =
    useQuery<Query>({
      query: GetAgreements,
      requestPolicy: 'cache-and-network',
      variables: {
        types: agreementTypes,
      },
    });

  const refresh = () => {
    refetchAgreements({ requestPolicy: 'network-only' });
  };

  const agreementsListDetails = data?.agreements;

  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();

  const responseError = useFormattedCombinedError(error);

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError?.title ?? defaultTitle,
        messageBody: responseError?.message ?? defaultMessage,
      }
    : null;

  return {
    agreementsListDetails,
    errorModel,
    loading,
    refresh,
  };
};

export default useAgreements;
